import { HeaderMall9 } from "../../../../../publicComponent/Header";
import Navigator from "../../../../../publicComponent/h5/Navigator";
import NoticeBar from "../../../../../publicComponent/NoticeBar";
import QRCode from "qrcode.react";
import cookies from "../../../../../utils/cookies";
import { useLocation, useNavigate } from "react-router";
import { useNavigateTo } from "../../../../../hooks/useNavigateTo";
import { useTranslation,getI18n } from "react-i18next";
import Buffer from "../../../../../publicComponent/Buffer";
import Pagination from "../../../../../publicComponent/Pagination";
import MyIntegralContext, {
  MyIntegralController,
  useMyIntegralContext,
} from "../../../../../reducer/moduleReducer/my/myIntegral";
import { useEffect } from "react";

function MyIntegralWrap() {
  const location = useLocation();
  const navigateTo = useNavigateTo();
  const { t } = useTranslation();
  const { getPointHistoryList } = MyIntegralController();
  const { state } = useMyIntegralContext();
  const { loading, integralList, total, query } = state;
  const lang = getI18n().language;

  useEffect(() => {
    if (!cookies.getToken()) {
      navigateTo(`/login?redirect=${location.pathname}`, { replace: true });
    } else {
      getPointHistoryList();
    }
  }, []);

  return (
    <Navigator.container className="container-center">
      <NoticeBar className="text-left">
        <p className="text-[#e58d40]">{t("提示：积分可以用来兑换指定商品")}</p>
      </NoticeBar>
      <h1 className="font-bold py-[30px] text-[24px] pb-[12px] mdmax:hidden">
        {t("我的积分")}
      </h1>

      {/* <div className="grid bg-[#f6f6f6] p-[50px] grid-cols-6 items-center mdmax:hidden">
          <div className="col-span-2 flex items-center">
            <div className="border w-[70px] h-[70px] bg-[#666] rounded-full"></div>
            <div className="ml-[20px]">
              <p className="text-[16px] mb-[8px]">阿斯顿</p>
              <p className="text-[14px]">会员号：11234567</p>
            </div>
          </div>
          <div className="col-span-1 text-center border-r border-[#d4d4d4]">
            <h1 className="font-bold text-[22px]">13010</h1>
            <p className="text-[#999] text-[14px]">当前积分</p>
          </div>
          <div className="col-span-1 text-center border-r border-[#d4d4d4]">
            <h1 className="font-bold text-[22px]">13010</h1>
            <p className="text-[#999] text-[14px]">累计积分</p>
          </div>
          <div className="col-span-1 text-center">
            <h1 className="font-bold text-[22px]">13010</h1>
            <p className="text-[#999] text-[14px]">累计消费</p>
          </div>
          <div className="col-span-1 text-center mx-auto">
            <QRCode value={'123'}/>
          </div>
        </div> */}

      <div className="px-[18px]">
        <p className="pt-[15px] pb-0 text-[16px]">{t("分值明细")}</p>

        <div className="py-[8px] divide-y divide-[#eee]">
          <Buffer.Loading loading={loading} />
          {integralList.length > 0 ? (
            <>
              {integralList.map((item, i) => (
                <div className="flex justify-between items-center" key={i}>
                  <div className="py-[12px]">
                    <p className="text-[16px] mb-[5px]">{lang === 'en'? item.noteEn:item.note}</p>
                    <p className="text-[#999] text-[13px]">{item.createTime}</p>
                  </div>
                  <p className="text-[#C8A05C] text-[16px]">+{item.point}</p>
                </div>
              ))}

              <div className="pt-[40px]">
                <Pagination
                  total={total}
                  current={query.page}
                  onChange={(page) => getPointHistoryList({ page })}
                  className="md:mb-[100px]"
                />
              </div>
            </>
          ) : (
            <Buffer.Empty content={t("暂无相关订单")} />
          )}
        </div>
      </div>
    </Navigator.container>
  );
}

export default function MyIntegral() {
  const { t } = useTranslation();
  return (
    <>
      <HeaderMall9 />
      <Navigator title={t("我的积分")} goback />
      <MyIntegralContext>
        <MyIntegralWrap />
      </MyIntegralContext>
    </>
  );
}
